import React from 'react';

function Container({children, style, className}) {
  return (
    <div
      className={`mx-auto w-[95vw] xl:w-[85vw] ${className&&className}`}
      style={style}
    >
      {children}
    </div>
  );
}

export default Container;
